import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {UserLevel} from '@netx/core-user-next/constants';
import {DataSetPref} from './constants';

/**
 * Can replace data set
 * @param {Backbone.View} v View instance
 */
export const canReplaceDataSet = (v: any) => {
	// Only CSV sourced dataSets can be replaced
	return v.model.get('source') === 'CSV File';
};

/** Is the user above the min user level? */
export const datamanagerAuthorized = () =>
	currentUserMeetsUserLevel(
		parseInt(getPreference(DataSetPref.MIN_USER_LEVEL) || '') ||
			UserLevel.MANAGER,
	);

/** Is datamanager enabled */
export const datamanagerEnabled = () =>
	getPreference(DataSetPref.ENABLED, true);
